import onlineTestReducer from "./onlineTestReducer";

const onlineTestReducers = {
    onlineTest: onlineTestReducer
};

export default onlineTestReducers;